import { useEffect, useState } from "react";
import { GetMoreContactsForAccountsModal } from "./modal";
import { CircularProgress } from "@mui/material";
import { GradientButton } from "./GradientButton";
import {
  useLazyGetAccountsForScrapingQuery,
  useGetCampaignSummaryQuery,
} from "../../api";
import { toast } from "react-toastify";
import { CustomToast } from "./CustomToast";
import { getErrorMessage } from "../../utils/getErrorMessage";

export const GetMoreContactsForAccountsBtn = ({
  campaign_id,
  fullWidth,
}: {
  campaign_id: string;
  fullWidth?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [getAccountsForScraping, { data, error, isError, isFetching }] =
    useLazyGetAccountsForScrapingQuery();

  const { data: summary } = useGetCampaignSummaryQuery({
    campaign_id,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(
        <CustomToast
          type="error"
          title="Failed to find more contacts."
          text={
            getErrorMessage(error).globalError ||
            "Something went wrong. Please try again"
          }
        />,
      );
    }
  }, [isError, error]);

  const isNoData =
    data && Object.values(data || []).every((list) => list.length === 0);

  const openModalHandler = () => {
    getAccountsForScraping(campaign_id)
      .unwrap()
      .then(() => setIsOpen(true));
  };

  const isDisabled =
    isFetching ||
    ["in_progress", "not_allowed"].includes(summary?.scraping_status || "") ||
    isNoData;

  return (
    <>
      <GradientButton
        fullWidth={fullWidth}
        onClick={openModalHandler}
        disabled={isDisabled}
      >
        {summary?.scraping_status === "in_progress" ? (
          <>
            <CircularProgress size={20} color="inherit" /> Search in progress
          </>
        ) : (
          <>
            {isFetching && <CircularProgress size={20} color="inherit" />}
            Explore Audience Expansion
          </>
        )}
      </GradientButton>
      {isOpen && data && (
        <GetMoreContactsForAccountsModal
          accountsForScraping={data}
          campaign_id={campaign_id}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};
